/* eslint-disable camelcase */
import { type UseMutationResult, useMutation } from 'react-query';

import {
  CustomReportsService,
  Wealthlane_ReportService_Dtos_CustomReport_CustomReportSaveAndRunResponseDto,
} from '../../services/wealthlane-report-services';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import _ from 'lodash';

const transformPayload = (payload: Record<string, any>) => {
  const newPayload = {
    ...payload,
    requiredFieldBuckets: payload.requiredFieldBuckets?.map((item: any) => ({
      ...item,
      userFieldFormats: item.userFieldFormats.map((format: any) => ({
        key: format.key,
        value: !_.isEmpty(format.value) ? format.value : format.placeholder,
        placeholder: format.placeholder,
      })),
    })),
    optionalFieldBuckets: payload.optionalFieldBuckets?.map((item: any) => ({
      ...item,
      userFieldFormats: item.userFieldFormats.map((format: any) => ({
        key: format.key,
        value: !_.isEmpty(format.value) ? format.value : format.placeholder,
        placeholder: format.placeholder,
      })),
    })),
  };
  return newPayload;
};

const usePostSubmitAndRunDynamicReport = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  openSubmitModal: () => void,
  setTaskReferanceNo?: any
): UseMutationResult<
  Wealthlane_ReportService_Dtos_CustomReport_CustomReportSaveAndRunResponseDto | undefined,
  unknown,
  any,
  unknown
> => {
  return useMutation(
    async (payload: any) => {
      let newPayload = { ...payload, reportConfigurationId: payload.id };
      newPayload = transformPayload(newPayload);
      return await handleRequest(
        CustomReportsService.postApiReportApiAppCustomReportsSubmitAndRunReport(newPayload)
      );
    },
    {
      onSuccess: async (
        response:
          | Wealthlane_ReportService_Dtos_CustomReport_CustomReportSaveAndRunResponseDto
          | undefined
      ) => {
        if (response && response?.isSuccess === true) {
          openSubmitModal();
          setTaskReferanceNo(response.taskRefrenceNo);
        } else if (response && response?.error) {
          toast.error(<ToastComponent label='Error' message={`${response?.error[0]}`} />);
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostSubmitAndRunDynamicReport;
